// Normalizes Plan of Care to one storage shape before an EHR field paste
// ({{planOfCare}} substitution in useEHR's lucasIntegrationGetContent).
//
// planOfCare is stored in two shapes. The backend generates an HTML string
// ("<strong>Problem - Chronic</strong><br>...====PLAN====<ul>..."); the chart UI
// rewrites it to a [{key, value}] array as a side effect of the first ICD-10
// order seed or any Plan of Care edit. lucasFormatVariable renders the array as
// an outline (each problem an outer bullet) but inserts the string as-is, so the
// same note synced differently depending on which shape it happened to be in —
// e.g. a re-record regenerates the string, the once-per-note seed never runs
// again, and the next sync loses the outline the first one had.

import { planOfCareToArray } from "./utils";

const PLAN_OF_CARE_VARIABLE = "local:planOfCare";

// The array shape for a string Plan of Care, or `value` unchanged when it is not
// a string Plan of Care or has no problem headers to structure around.
export function normalizePlanOfCareForSync(varName, value) {
  if (varName !== PLAN_OF_CARE_VARIABLE) return value;
  if (typeof value !== "string" || value.trim() === "") return value;

  const items = planOfCareToArray(value);
  // A headerless narrative parses to one value-less item per paragraph; keep it
  // as prose instead of turning every paragraph into a bullet.
  if (!Array.isArray(items) || !items.some((item) => item.value)) return value;
  return items;
}
